import React, { useEffect } from "react";
import PropTypes from "prop-types";

function FullScreenModal({ children, backgroundColor }) {
  useEffect(() => {
    $("body").css("overflow", "hidden");

    return () => {
      $("body").css("overflow", "auto");
    };
  }, []);

  return (
    <div className="component-full-screen-modal" style={{ backgroundColor }}>
      {children}
    </div>
  );
}

FullScreenModal.propTypes = {
  children: PropTypes.array,
  backgroundColor: PropTypes.string,
};

export default FullScreenModal;
